import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import LabelEditorCtrl from '@webapp/controllers/label/label-editor';
import RosterBox from '@webapp/controllers/label/label-editor/roster-box';
import CreateRoster from '@webapp/controllers/label/create-roster';
// Store
import { GetRosters } from '@webapp/store/rosters/action-creators';
import AppState from '@webapp/store/state';

interface RosterManagementPageProps {
  className?: string;
  labelId?: string;
  getRosters: (labelId: string) => GetRosters;
}

const mapStateToProps = (state: AppState) => ({
  labelId: state.recordLabels.active?.id,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getRosters: (labelId: string) => dispatch(new GetRosters(labelId)),
});

const RosterManagementPage: React.FC<RosterManagementPageProps> = (props) => {
  const { getRosters, labelId } = props;

  React.useEffect(() => {
    if (labelId) {
      getRosters(labelId);
    }
  }, [getRosters, labelId]);

  return (
    <>
      <LabelEditorCtrl className={props.className} />
      <CreateRoster />
      <RosterBox />
    </>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RosterManagementPage);
